const DEFAULT_TRUNCATE_LENGTH = 80;
const DEFAULT_PIN_LENGTH = 80;

/** Aligned with API validation (`StoreClientRequest` / `UpdateClientRequest`) — GAP-F2-126. */
export const CLIENT_OPERATIONAL_NOTES_MAX_LENGTH = 8000;

export const hasClientOperationalNotes = (notes?: string | null): boolean =>
  Boolean(notes?.trim());

export const truncateClientNotes = (
  notes: string,
  maxLength: number = DEFAULT_TRUNCATE_LENGTH
): string => {
  const normalized = notes.trim();

  if (normalized.length <= maxLength) {
    return normalized;
  }

  return `${normalized.slice(0, maxLength).trimEnd()}…`;
};

/**
 * Soft pin: first non-empty line of notes (no separate DB column).
 * Used as the short alert on list / picker / agenda surfaces.
 */
export const getClientNotesPinLine = (
  notes?: string | null,
  maxLength: number = DEFAULT_PIN_LENGTH
): string | null => {
  if (!notes?.trim()) {
    return null;
  }

  const firstLine =
    notes
      .trim()
      .split(/\r?\n/)
      .map((line) => line.trim())
      .find((line) => line.length > 0) ?? "";

  if (!firstLine) {
    return null;
  }

  return truncateClientNotes(firstLine, maxLength);
};

export const clientNotesNeedExpand = (
  notes?: string | null,
  previewLength: number = DEFAULT_TRUNCATE_LENGTH
): boolean => {
  const normalized = notes?.trim() ?? "";

  if (!normalized) {
    return false;
  }

  if (normalized.includes("\n")) {
    return true;
  }

  return normalized.length > previewLength;
};

export const buildClientNotesTooltip = (
  notes: string,
  format: (preview: string) => string,
  maxLength: number = 120
): string => format(truncateClientNotes(notes, maxLength));
